import React from 'react';
import {Button, keyframes, styled} from '@mui/material';
import Bg from '../../images/bg.png';
import {colors} from '../../styles/globalStyles';
import {ReactComponent as ArrowRight} from '../../images/arrow_right.svg';

const PatternedButtonStyle = styled(Button)(({is_gray_when_disabled, is_accent, is_shine}) => ({
    padding: '17px 21px 17px 27px',
    width: '100%',
    minHeight: 86,
    justifyContent: 'space-between',
    textTransform: 'none',
    textAlign: 'left',

    background: is_accent ? `url(${Bg}), linear-gradient(267.39deg, #FFD952 -8.46%, #11D1A3 39.05%, #1198D1 92.96%)` : `url(${Bg}), linear-gradient(53.36deg, #3B4EF6 -32.52%, #3BC9F6 69.33%)`,
    color: colors.white,
    borderRadius: 40,

    fontSize: 24,
    fontWeight: 700,
    lineHeight: '110%',
    letterSpacing: '0.01%',
    fontFamily: 'Onest',
    overflowX: 'hidden',

    zIndex: 1,

    animation: is_shine ? `${scale} 1s cubic-bezier(0.74, 0, 0.22, 1) infinite alternate` : 'none',

    '&:hover': {
        background: is_accent ? `url(${Bg}), linear-gradient(267.39deg, #FFD952 -8.46%, #11D1A3 39.05%, #1198D1 92.96%)` : `url(${Bg}), linear-gradient(53.36deg, #3B4EF6 -32.52%, #3BC9F6 69.33%)`,
        filter: 'brightness(95%)',
    },

    '&:disabled': {
        color: colors.white,
        opacity: is_gray_when_disabled === 'true' ? 1 : 0.5,
        filter: is_gray_when_disabled === 'true' ? 'grayscale(1)' : 'grayscale(0)',
    },

    '&::before': {
        display: is_shine ? 'block' : 'none',
        animation: `${shine} 3s cubic-bezier(0.74, 0, 0.22, 1) infinite`,
        content: "''",
        position: 'absolute',
        width: '300px',
        height: '100%',
        backgroundImage: 'linear-gradient(120deg, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 80%)',
        top: 0,
        left: '-150px',
        opacity: 0.85,
    },

}));

const shine = keyframes`
  0% {
    left: -300px;
  }
  60% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
`;

const scale = keyframes`
  0% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(0.98);
  }
`;

const ArrowWrap = styled('div')({
    width: 52,
    height: 52,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: colors.white,
    borderRadius: 23,

    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
    },
});

const PatternedButton = ({
                             onClick,
                             label,
                             disabled = false,
                             endIcon,
                             isGrayWhenDisabled = false,
                             isAccent = false,
                             isShine = false
                         }) => (
    <PatternedButtonStyle is_accent={isAccent} is_shine={isShine
    }
                          is_gray_when_disabled={isGrayWhenDisabled.toString()}
                          endIcon={
                              endIcon !== null ? (
                                  <ArrowWrap>
                                      <ArrowRight fill="#3BC9F6"/>
                                  </ArrowWrap>
                              ) : null
                          }
                          onClick={onClick}
                          disabled={disabled}
    >
        {label}
    </PatternedButtonStyle>
);

export default PatternedButton;
